import React, { useEffect, useState } from 'react';
import FrameAnimation from './FrameAnimation';

// Import frames for daily_main_normal_person
import person_00 from '../images/Animations/Programs/daily_main_normal_person/01.png';
import person_01 from '../images/Animations/Programs/daily_main_normal_person/02.png';
import person_02 from '../images/Animations/Programs/daily_main_normal_person/03.png';
import person_03 from '../images/Animations/Programs/daily_main_normal_person/04.png';
import person_04 from '../images/Animations/Programs/daily_main_normal_person/05.png';
import person_05 from '../images/Animations/Programs/daily_main_normal_person/06.png';
import person_06 from '../images/Animations/Programs/daily_main_normal_person/07.png';
import person_07 from '../images/Animations/Programs/daily_main_normal_person/08.png';
import person_08 from '../images/Animations/Programs/daily_main_normal_person/09.png';
import person_09 from '../images/Animations/Programs/daily_main_normal_person/10.png';
import person_10 from '../images/Animations/Programs/daily_main_normal_person/11.png';
import person_11 from '../images/Animations/Programs/daily_main_normal_person/12.png';
import person_12 from '../images/Animations/Programs/daily_main_normal_person/13.png';
import person_13 from '../images/Animations/Programs/daily_main_normal_person/14.png';
import person_14 from '../images/Animations/Programs/daily_main_normal_person/15.png';
import person_15 from '../images/Animations/Programs/daily_main_normal_person/16.png';
import person_16 from '../images/Animations/Programs/daily_main_normal_person/17.png';
import person_17 from '../images/Animations/Programs/daily_main_normal_person/18.png';
import person_18 from '../images/Animations/Programs/daily_main_normal_person/19.png';
import person_19 from '../images/Animations/Programs/daily_main_normal_person/20.png';
import person_20 from '../images/Animations/Programs/daily_main_normal_person/21.png';
import person_21 from '../images/Animations/Programs/daily_main_normal_person/22.png';
import person_22 from '../images/Animations/Programs/daily_main_normal_person/23.png';
import person_23 from '../images/Animations/Programs/daily_main_normal_person/24.png';
import person_24 from '../images/Animations/Programs/daily_main_normal_person/25.png';



// Import frames for daily_main_black_sfx
import sfx_01 from '../images/Animations/Programs/daily_main_black_sfx/01.png';
import sfx_02 from '../images/Animations/Programs/daily_main_black_sfx/02.png';
import sfx_03 from '../images/Animations/Programs/daily_main_black_sfx/03.png';
import sfx_04 from '../images/Animations/Programs/daily_main_black_sfx/04.png';
import sfx_05 from '../images/Animations/Programs/daily_main_black_sfx/05.png';
import sfx_06 from '../images/Animations/Programs/daily_main_black_sfx/06.png';
import sfx_07 from '../images/Animations/Programs/daily_main_black_sfx/07.png';
import sfx_08 from '../images/Animations/Programs/daily_main_black_sfx/08.png';
import sfx_09 from '../images/Animations/Programs/daily_main_black_sfx/09.png';
import sfx_10 from '../images/Animations/Programs/daily_main_black_sfx/10.png';
import sfx_11 from '../images/Animations/Programs/daily_main_black_sfx/11.png';
import sfx_12 from '../images/Animations/Programs/daily_main_black_sfx/12.png';
import sfx_13 from '../images/Animations/Programs/daily_main_black_sfx/13.png';
import sfx_14 from '../images/Animations/Programs/daily_main_black_sfx/14.png';
import sfx_15 from '../images/Animations/Programs/daily_main_black_sfx/15.png';
import sfx_16 from '../images/Animations/Programs/daily_main_black_sfx/16.png';
import sfx_17 from '../images/Animations/Programs/daily_main_black_sfx/17.png';
import sfx_18 from '../images/Animations/Programs/daily_main_black_sfx/18.png';
import sfx_19 from '../images/Animations/Programs/daily_main_black_sfx/19.png';
import sfx_20 from '../images/Animations/Programs/daily_main_black_sfx/20.png';
import sfx_21 from '../images/Animations/Programs/daily_main_black_sfx/21.png';
import sfx_22 from '../images/Animations/Programs/daily_main_black_sfx/22.png';
import sfx_23 from '../images/Animations/Programs/daily_main_black_sfx/23.png';
import sfx_24 from '../images/Animations/Programs/daily_main_black_sfx/24.png';
import sfx_25 from '../images/Animations/Programs/daily_main_black_sfx/25.png';

// Import frames for daily_main_success_01
import success01_01 from '../images/Animations/Programs/daily_main_success_01/01.png';
import success01_02 from '../images/Animations/Programs/daily_main_success_01/02.png';
import success01_03 from '../images/Animations/Programs/daily_main_success_01/03.png';
import success01_04 from '../images/Animations/Programs/daily_main_success_01/04.png';
import success01_05 from '../images/Animations/Programs/daily_main_success_01/05.png';
import success01_06 from '../images/Animations/Programs/daily_main_success_01/06.png';
import success01_07 from '../images/Animations/Programs/daily_main_success_01/07.png';
import success01_08 from '../images/Animations/Programs/daily_main_success_01/08.png';
import success01_09 from '../images/Animations/Programs/daily_main_success_01/09.png';
import success01_10 from '../images/Animations/Programs/daily_main_success_01/10.png';
import success01_11 from '../images/Animations/Programs/daily_main_success_01/11.png';
import success01_12 from '../images/Animations/Programs/daily_main_success_01/12.png';
import success01_13 from '../images/Animations/Programs/daily_main_success_01/13.png';
import success01_14 from '../images/Animations/Programs/daily_main_success_01/14.png';
import success01_15 from '../images/Animations/Programs/daily_main_success_01/15.png';
import success01_16 from '../images/Animations/Programs/daily_main_success_01/16.png';
import success01_17 from '../images/Animations/Programs/daily_main_success_01/17.png';
import success01_18 from '../images/Animations/Programs/daily_main_success_01/18.png';
import success01_19 from '../images/Animations/Programs/daily_main_success_01/19.png';
import success01_20 from '../images/Animations/Programs/daily_main_success_01/20.png';
import success01_21 from '../images/Animations/Programs/daily_main_success_01/21.png';
import success01_22 from '../images/Animations/Programs/daily_main_success_01/22.png';
import success01_23 from '../images/Animations/Programs/daily_main_success_01/23.png';
import success01_24 from '../images/Animations/Programs/daily_main_success_01/24.png';
import success01_25 from '../images/Animations/Programs/daily_main_success_01/25.png';

// Import frames for daily_main_success_02
import success02_01 from '../images/Animations/Programs/daily_main_success_02/01.png';
import success02_02 from '../images/Animations/Programs/daily_main_success_02/02.png';
import success02_03 from '../images/Animations/Programs/daily_main_success_02/03.png';
import success02_04 from '../images/Animations/Programs/daily_main_success_02/04.png';
import success02_05 from '../images/Animations/Programs/daily_main_success_02/05.png';
import success02_06 from '../images/Animations/Programs/daily_main_success_02/06.png';
import success02_07 from '../images/Animations/Programs/daily_main_success_02/07.png';
import success02_08 from '../images/Animations/Programs/daily_main_success_02/08.png';
import success02_09 from '../images/Animations/Programs/daily_main_success_02/09.png';
import success02_10 from '../images/Animations/Programs/daily_main_success_02/10.png';
import success02_11 from '../images/Animations/Programs/daily_main_success_02/11.png';
import success02_12 from '../images/Animations/Programs/daily_main_success_02/12.png';
import success02_13 from '../images/Animations/Programs/daily_main_success_02/13.png';
import success02_14 from '../images/Animations/Programs/daily_main_success_02/14.png';
import success02_15 from '../images/Animations/Programs/daily_main_success_02/15.png';
import success02_16 from '../images/Animations/Programs/daily_main_success_02/16.png';
import success02_17 from '../images/Animations/Programs/daily_main_success_02/17.png';
import success02_18 from '../images/Animations/Programs/daily_main_success_02/18.png';
import success02_19 from '../images/Animations/Programs/daily_main_success_02/19.png';
import success02_20 from '../images/Animations/Programs/daily_main_success_02/20.png';
import success02_21 from '../images/Animations/Programs/daily_main_success_02/21.png';
import success02_22 from '../images/Animations/Programs/daily_main_success_02/22.png';
import success02_23 from '../images/Animations/Programs/daily_main_success_02/23.png';
import success02_24 from '../images/Animations/Programs/daily_main_success_02/24.png';
import success02_25 from '../images/Animations/Programs/daily_main_success_02/25.png';

const personFrames = [
  person_00, person_01, person_02, person_03, person_04, person_05,
  person_06, person_07, person_08, person_09, person_10, person_11,
  person_12, person_13, person_14, person_15, person_16, person_17,
  person_18, person_19, person_20, person_21, person_22, person_23,
  person_24
];

const sfxFrames = [
  sfx_01, sfx_02, sfx_03, sfx_04, sfx_05,
  sfx_06, sfx_07, sfx_08, sfx_09, sfx_10,
  sfx_11, sfx_12, sfx_13, sfx_14, sfx_15,
  sfx_16, sfx_17, sfx_18, sfx_19, sfx_20,
  sfx_21, sfx_22, sfx_23, sfx_24, sfx_25
];

const success01Frames = [
  success01_01, success01_02, success01_03, success01_04, success01_05,
  success01_06, success01_07, success01_08, success01_09, success01_10,
  success01_11, success01_12, success01_13, success01_14, success01_15,
  success01_16, success01_17, success01_18, success01_19, success01_20,
  success01_21, success01_22, success01_23, success01_24, success01_25
];

const success02Frames = [
  success02_01, success02_02, success02_03, success02_04, success02_05,
  success02_06, success02_07, success02_08, success02_09, success02_10,
  success02_11, success02_12, success02_13, success02_14, success02_15,
  success02_16, success02_17, success02_18, success02_19, success02_20,
  success02_21, success02_22, success02_23, success02_24, success02_25
];

interface DailyAnimationProps {
  isPlaying: boolean;
  successTrigger?: number; // timestamp to trigger success animation
  className?: string;
  style?: React.CSSProperties;
}

const DailyAnimation: React.FC<DailyAnimationProps> = ({ isPlaying, successTrigger, className, style }) => {
  const [animationPhase, setAnimationPhase] = useState<'normal' | 'success_01' | 'success_02'>('normal');

  useEffect(() => {
    if (successTrigger) {
      setAnimationPhase('success_01');
    }
  }, [successTrigger]);

  const handleAnimationEnd = () => {
    if (animationPhase === 'success_01') {
      setAnimationPhase('success_02');
    } else if (animationPhase === 'success_02') {
      setAnimationPhase('normal');
    }
  };

  return (
    <div className={className} style={{ position: 'relative', width: '100%', height: '100%', ...style }}>
      {/* SFX Layer */}
      {animationPhase === 'normal' && (
        <FrameAnimation
          frames={sfxFrames}
          animationName="DailySfxAnimation"
          duration={2} 
          isPlaying={isPlaying}
          loop={true}
          className="daily-sfx"
          style={{
            position: 'absolute',
            top: '10%',
            left: '10%',
            width: '80%',
            height: '80%',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            zIndex: 2
          }}
        />
      )}

      {animationPhase === 'success_01' && (
        <FrameAnimation
          frames={success01Frames}
          animationName="DailySuccess01Animation"
          duration={1} // Assuming same duration logic
          isPlaying={true}
          loop={false}
          iterationCount={1}
          className="daily-success-01"
          onAnimationEnd={handleAnimationEnd}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            zIndex: 2
          }}
        />
      )}

      {animationPhase === 'success_02' && (
        <FrameAnimation
          frames={success02Frames}
          animationName="DailySuccess02Animation"
          duration={1}
          isPlaying={true}
          loop={false}
          iterationCount={2}
          className="daily-success-02"
          onAnimationEnd={handleAnimationEnd}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            zIndex: 2
          }}
        />
      )}
      
      {/* Person Layer - Placed on top or bottom depending on visual requirement. Usually characters are on top of effects or vice versa. 
         "daily_main_black_sfx" might be a background aura or a foreground overlay. 
         Given "sfx", it might be an overlay. But "black sfx" might be a shadow/aura.
         Let's put person on top for now. If it looks wrong, we can swap.
      */}
      <FrameAnimation
        frames={personFrames}
        animationName="DailyPersonAnimation"
        duration={2}
        isPlaying={isPlaying}
        loop={true}
        className="daily-person"
        style={{
          position: 'absolute',
          top: '10%',
          left: '10%',
          width: '80%',
          height: '80%',
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center'
        }}
      />
    </div>
  );
};

export default DailyAnimation;
